import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getAuthHeaderValue } from "@src/appV2/Auth/cognito/getAuthorizationHeader";
import { environmentConfig } from "@src/appV2/environment";
import fetch from "cross-fetch";

const httpLink = createHttpLink({
  uri: environmentConfig.REACT_APP_DOCUMENTS_SERVICE_URL,
  fetch,
});

const authLink = setContext(async () => {
  const authHeaderValue = await getAuthHeaderValue();
  return {
    headers: {
      Authorization: authHeaderValue || localStorage.getItem("authToken"),
    },
  };
});

const link = authLink.concat(httpLink);

const GraphQlClient = new ApolloClient({
  link,
  cache: new InMemoryCache(),
});

export { GraphQlClient };
